import { render, staticRenderFns } from "./MenuLayout.vue?vue&type=template&id=615def8b&scoped=true&"
import script from "./MenuLayout.vue?vue&type=script&lang=js&"
export * from "./MenuLayout.vue?vue&type=script&lang=js&"
import style0 from "./MenuLayout.vue?vue&type=style&index=0&id=615def8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615def8b",
  null
  
)

export default component.exports